import { useMemo } from "react";

import { getConnectionNodesTyped } from "@/utils/relay";
import {
  hasUsablePermissions,
  isHiddenHierarchyParent,
} from "@/utils/workspacePermissions";

import { BasicDetailedUserFragment } from "./queries.graphql";
import useBasicData from "./useBasicData";

type WorkspaceMembership = NonNullable<
  NonNullable<BasicDetailedUserFragment["memberships"]["edges"]>[number]
>["node"] & {};

export const useWorkspaceMembership = (): ReturnType<typeof useBasicData> & {
  filteredMemberships: WorkspaceMembership[];
} => {
  const { user, ...rest } = useBasicData();

  const memberships = useMemo(
    () => (user?.memberships ? getConnectionNodesTyped(user.memberships) : []),
    [user?.memberships],
  );

  const filteredMemberships = useMemo(() => {
    return memberships.filter(
      (membership) =>
        hasUsablePermissions(membership.workspace) &&
        !isHiddenHierarchyParent(membership.workspace),
    );
  }, [memberships]);

  return { filteredMemberships, user, ...rest };
};
export type { WorkspaceMembership };
